import storeURLQuery from "./StoreURLQuery";
import { get } from "./ApiClient";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import {
  agencyConfigError,
  integrationDisabled,
  integrationEnabled,
  setTaggingOptions,
  setGenericExportOptions,
  setUserName,
} from "./Store/mutations";

const useStartUp = () => {
  storeURLQuery();
  const dispatch = useDispatch();
  const FetchAgencyConfig = async function () {
    try {
      const response = await get("AgencyConfig/vmeli");
      const agencyConfig = response.data;
      localStorage.setItem("AgencyConfig", JSON.stringify(agencyConfig));

      var userName = jwtDecode(localStorage.getItem("token")).name;
      if (typeof userName === "string" && userName.length !== 0) {
        dispatch(setUserName(userName));
      }

      // Fetch and configure Generic Export options
      try {
        const exportConfigResponse = await get(
          `GenericExports/Configurations/${agencyConfig.agencyKey}`
        );

        // Filter to only enabled configurations
        const enabledConfigs = exportConfigResponse.data.filter(
          (item) =>
            item.data?.configuration?.videoManagerExportOptions?.enabled === true
        );

        // Extract IDs and names from enabled configurations
        const configurationIds = enabledConfigs.map(
          (item) => item.data.configuration.configurationId
        );

        const configurationNames = enabledConfigs.reduce((acc, item) => {
          const config = item.data.configuration;
          acc[config.configurationId] = config.configurationName;
          return acc;
        }, {});

        // Enable Generic Exports if at least one configuration is enabled
        const enabled = enabledConfigs.length > 0;

        dispatch(
          setGenericExportOptions(enabled, configurationIds, configurationNames)
        );
      } catch (error) {
        console.error("Failed to fetch export configurations:", error);
        // If API call fails, disable generic exports
        dispatch(setGenericExportOptions(false, [], {}));
      }


      const delimiter =
        agencyConfig.taggingOptions.secondaryTagMultiTagDelimiter === "\x00"
          ? ","
          : agencyConfig.taggingOptions.secondaryTagMultiTagDelimiter;

      const {
        disableMultiTag,
        incidentNumberTagName,
        rmsNumberTagName,
        natureCodeTagName,
      } = agencyConfig.taggingOptions;

      dispatch(
        setTaggingOptions(
          delimiter,
          disableMultiTag,
          incidentNumberTagName,
          rmsNumberTagName,
          natureCodeTagName
        )
      );
    } catch (error) {
      dispatch(agencyConfigError(error));
    }
  };

  if (localStorage.getItem("token") !== null) {
    dispatch(integrationEnabled());
    FetchAgencyConfig();
  } else dispatch(integrationDisabled());
};

export default useStartUp;
